module.exports = __webpack_public_path__ + "static/media/eleves.90945127.png";